import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetRfidBadgeOrdersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/rfid-badge-orders/get-rfid-badge-orders-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterEmspBoRfidBadgeOrderListContext } from '../../emsp-bo-rfid-badge-order.context';
import { EmspBoRfidBadgeOrderListFilterFormStep1Controller } from '../emsp-bo-rfid-badge-order-list-filter-form-step-1/emsp-bo-rfid-badge-order-list-filter-form-step-1.controller';

export interface EmspBoRfidBadgeOrderListFilterFormControllerProps {
  onError: SubmitErrorHandler<GetRfidBadgeOrdersPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetRfidBadgeOrdersPaginatedModel>;
  onCancel: () => void;
}

export const EmspBoRfidBadgeOrderListFilterFormController = (
  props: EmspBoRfidBadgeOrderListFilterFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterEmspBoRfidBadgeOrderListContext();

  return (
    <MultiStepFormProvider<GetRfidBadgeOrdersPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      items={[
        {
          fields: ['status'],
          component: <EmspBoRfidBadgeOrderListFilterFormStep1Controller />,
        },
      ]}
    />
  );
};
